module.exports = __webpack_public_path__ + "media/images/pen-4664958fe7a07ed8bb3f63b223302b7b.svg";